import DOMPurify from 'dompurify';

export function decodeSafeATags(str) {
  if (!str || typeof str !== 'string') return str;

  const aOpenTagRegex = /&lt;a\s[\s\S]*?&gt;|&lt;a&gt;/gi;
  const aCloseTagRegex = /&lt;\/a&gt;/gi;

  const entities = {
    '&amp;': '&', '&lt;': '<', '&gt;': '>',
    '&quot;': '"', '&#39;': "'", '&#x27;': "'"
  };

  let safeStr = str.replace(aCloseTagRegex, '</a>');

  safeStr = safeStr.replace(aOpenTagRegex, (matchedTag) => {
    let decodedTag = matchedTag;
    for (let i = 0; i < 3 && /&[#a-z0-9]+;/i.test(decodedTag); i++) {
      decodedTag = decodedTag.replace(/&amp;|&lt;|&gt;|&quot;|&#39;|&#x27;/ig, 
        (m) => entities[m.toLowerCase()]
      );
    }

    const hrefMatch = decodedTag.match(/href=(["'])(.*?)\1/i); 
    
    if (hrefMatch) {
      let url = hrefMatch[2].trim();
      const badProtocols = /^(javascript|vbscript|data):/i;
      if (badProtocols.test(url)) {
        return '<a>'; 
      }
      return `<a href="${url}" target="_blank" rel="noopener noreferrer">`;
    }
    return '<a>';
  });
  return DOMPurify.sanitize(safeStr, { ADD_TAGS: ['iframe'] });
}
